<template>
  <div class="modal modall-overlay draggable" @mousedown="startDrag" :class="{ dragging: isDragging }">
    <div class="modall" :style="{ top: `${posY}px`, left: `${posX}px` }">
      <div class="modall-header">
        <h3>{{ title }}</h3>
        <button @click="closeModal">X</button>
      </div>
      <div class="modall-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Modal"
    }
  },
  data() {
    return {
      isDragging: false,
      offsetX: 0,
      offsetY: 0,
      posX: 0,
      posY: 20
    };
  },
  mounted(){
    this.posX = (window.innerWidth - 600) / 2;
  },
  methods: {
    startDrag(event) {
      if (event.target.tagName === "SPAN" || event.target.tagName === "INPUT" || event.target.tagName === "TEXTAREA" || event.target.tagName === "SELECT") {
        return;
      }
      this.isDragging = true;
      this.offsetX = event.clientX - this.posX;
      this.offsetY = event.clientY - this.posY;

      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
    },
    onDrag(event) {
      if (this.isDragging) {
        this.posX = event.clientX - this.offsetX;
        this.posY = event.clientY - this.offsetY;
      }
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.modall-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.5);
}

.modall {
  position: absolute;
  z-index: 1000;
  background-color: white;
  width: 600px;
  height: 90vh;
  overflow: auto;
  padding: 0px;
  border-radius: 10px;
}

.modall-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1055;
  padding: 20px;
  border-bottom: solid 1px #ccc;
}

.modall-header h3{
    margin: 0;
}

.modall-body {
  margin-top: 10px;
}
.draggable {
  cursor: grab;
}

.dragging {
  cursor: grabbing;
}
</style>